import MUIContainer from '@mui/material/Container'
import React from 'react'

interface ContainerProps extends React.ComponentProps<typeof MUIContainer> {}

export const Container: React.FC<ContainerProps> = (props) => {
  return <MUIContainer {...props} />
}
